<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <button class="navbar-toggler" type="button" @click="toggleSideBar = true">
      <img src="/images/bars.png" />
    </button>
    <a
      href="javascript:void(0)"
      class="menu_overlay"
      :class="{ show: toggleSideBar }"
      @click.prevent="toggleSideBar = false"
    ></a>
    <div class="navbar-collapse" :class="{ show: toggleSideBar }">
      <ul class="navbar-nav">
        <li>
          <div
            class="mobile-back text-right"
            @click.stop="toggleSideBar = false"
          >
            {{ _T('Back') }}
            <i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
          </div>
        </li>
        <li class="nav-item" :class="{ active: $route.name == 'home' }">
          <router-link :to="{ name: 'home' }" class="nav-link">
            {{ _T('HOME') }}
          </router-link>
        </li>
        <li
          v-if="currentBrand && currentBrand.offers"
          class="nav-item"
          :class="{ active: $route.name == 'offers' }"
        >
          <router-link :to="{ name: 'offers' }" class="nav-link">
            {{ _T('OFFERS') }}
          </router-link>
        </li>
        <li
          v-if="!domainBasedBrand"
          class="nav-item"
          :class="{ active: $route.name == 'partner_with_us' }"
        >
          <router-link :to="{ name: 'partner_with_us' }" class="nav-link">
            {{ _T('PARTNER WITH US') }}
          </router-link>
        </li>
        <li
          class="nav-item d-md-none"
          v-for="(page, pIndex) of all_static_pages.filter(e => e.shown_menu)"
          :key="pIndex"
        >
          <router-link
            v-if="page.slug === 'about'"
            :to="{ name: 'about_us' }"
            class="nav-link"
            :class="{ active: $route.name == 'about_us' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else-if="page.slug === 'faq'"
            :to="{ name: 'faq' }"
            class="nav-link"
            :class="{ active: $route.name == 'faq' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else-if="page.slug === 'contact-us'"
            :to="{ name: 'contact_us' }"
            class="nav-link"
            :class="{ active: $route.name == 'contact_us' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else-if="page.slug === 'terms-condition'"
            :to="{ name: 'terms' }"
            class="nav-link"
            :class="{ active: $route.name == 'terms' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else-if="page.slug === 'privacy-policy'"
            :to="{ name: 'privacy' }"
            class="nav-link"
            :class="{ active: $route.name == 'privacy' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else-if="page.slug === 'how-it-works'"
            :to="{ name: 'how_it_work' }"
            class="nav-link"
            :class="{ active: $route.name == 'how_it_work' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
          <router-link
            v-else
            :to="{ name: 'to_page', params: { page_slug: page.slug } }"
            class="nav-link"
            :class="{ active: $route.name == 'to_page' }"
          >
            {{ _T(page.page_title) }}
          </router-link>
        </li>
      </ul>
      <div class="debug" v-if="debug">
        <h4 style="border-bottom: 1px solid #ccc;">Debug Info</h4>
        <div>Country: {{ selectedCountry }}</div>
        <div>Location City: {{ locationCity }}</div>
        <div>Store City: {{ storeCity }}</div>
        <div>Price City: {{ priceCity }}</div>
        <div>Da: {{ selectedDaId }}</div>
        <div>store id: {{ currentStore && currentStore._id }}</div>
        <div>store name: {{ currentStore && currentStore.name }}</div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  data() {
    return {
      toggleSideBar: false,
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler() {
        this.toggleSideBar = false
      },
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      'all_static_pages_by_slug_search',
      'domainBasedBrand',
      'all_static_pages',
      'selectedCountry',
      'locationCity',
      'storeCity',
      'priceCity',
      'currentStore',
      'selectedDaId',
      'currentBrand',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.mobile-back {
  display: none;
}
.navbar-toggler {
  padding-left: 0;
  padding-right: 0;
  border: none;
  img {
    width: $px20;
  }
}
.navbar {
  padding: 0;
  .menu_overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba($black, 0.5);
    z-index: 2;
    display: none;
    &.show {
      display: block;
    }
  }
  .navbar-nav {
    .nav-item {
      font-size: 1rem;
      text-transform: capitalize;
      .active {
        color: $color-primary;
        font-weight: 600;
      }
    }
  }
}
.navbar-light {
  .navbar-nav {
    .nav-link {
      text-transform: uppercase;
      color: $black;
      &:hover {
        color: $color-primary;
      }
    }
    .active {
      > .nav-link {
        color: $color-primary;
        font-weight: 600;
      }
    }
  }
}
@media (max-width: 991px) {
  .mobile-back {
    padding-bottom: $px15;
    font-size: $px18;
    font-weight: 700;
    text-transform: uppercase;
    border-bottom: $px1 solid $light-border;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .navbar-collapse {
    position: fixed;
    right: -$px290;
    top: 0;
    width: $px280;
    background-color: $white;
    z-index: 6;
    height: 100vh;
    padding: $px20;
    box-shadow: 0 0 $px8 0 rgba($black, 0.25);
    transition: all 0.5s ease;
    &.show {
      right: 0;
      transition: all 0.5s ease;
    }
  }
}
.body-rtl {
  .navbar-nav {
    text-align: right;
  }
}
.debug {
  position: fixed;
  left: 1rem;
  top: 0;
  background-color: #fff;
  border: 1px solid red;
  padding: 0.5rem;
  z-index: 9999999;
}
</style>
